<template>
  <div class="field-textarea" v-if="isVisible">
    <textarea :id="'form-' + field.form_key"
           class="form-control"
           :class="{ 'field-error': field.hasError }"
           v-model="answer"
           :tabIndex="question.id"
           :placeholder="field.placeholder || ''"
           :name="field.form_key"
           cols="30" rows="3"
           :autocomplete="field.form_key"
           :ref="'field_' + field.form_key"
           @focus="$emit('questionSelected', question.order)"
    ></textarea>

  </div>
</template>
<script>
import elementMixins from '../mixins/elements'
export default {
  name: 'LUTextarea',
  props: [
    'question',
    'field',
    'answers'
  ],
  mixins: [elementMixins]
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/elements/Textarea.vue